module.exports = __webpack_public_path__ + "img/small_eye_chart02.89203c35.jpg";